//import { LocationModule } from './modules/admin/location/location-module';
import { Route } from '@angular/router';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { InitialDataResolver } from 'app/app.resolvers';
import { RouteGuard } from './core/auth/guards/route.guard';
// import { FormWizardComponent } from './modules/admin/form-wizard/form-wizard.component';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // Redirect empty path to '/example'
    {path: '', pathMatch : 'full', redirectTo: 'user/sign-in'},

    // Redirect signed in user to the '/example'
    //
    // After the user signs in, the sign in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    {path: 'signed-in-redirect', pathMatch : 'full', redirectTo: 'example'},

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.module').then(m => m.AuthSignOutModule)},
            {path: 'confirmation-required', loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.module').then(m => m.AuthConfirmationRequiredModule)},
            {path: 'forgot-password', loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.module').then(m => m.AuthForgotPasswordModule)},
            {path: 'reset-password', loadChildren: () => import('app/modules/auth/reset-password/reset-password.module').then(m => m.AuthResetPasswordModule)},
            {path: 'set-password', loadChildren: () => import('app/modules/auth/reset-password/reset-password.module').then(m => m.AuthResetPasswordModule)},
            {path: 'admin/sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.module').then(m => m.AuthSignInModule)},
            {path: 'user/sign-in', loadChildren: () => import('app/modules/auth/sign-in-sso/sign-in-sso.module').then(m => m.SignInSsoModule)},
            {path: 'sign-up', loadChildren: () => import('app/modules/auth/sign-up/sign-up.module').then(m => m.AuthSignUpModule)}
        ]
    },


    // Landing routes
    {
        path: '',
        component  : LayoutComponent,
        children   : [
            {path: 'public/home',
            data: {
                layout: 'empty'
            },
             loadChildren: () => import('app/modules/landing/home/home.module').then(m => m.LandingHomeModule)},
            {path: 'public',
            data: {
                layout: 'material'
            },
             loadChildren: () => import('app/modules/landing/public/upload/upload.module').then(m => m.UploadModule)
        },
        ]
    },

    // Admin routes
    {
        path       : '',
        canActivate: [AuthGuard, RouteGuard],
        canActivateChild: [AuthGuard, RouteGuard],
        component  : LayoutComponent,
        resolve    : {
            initialData: InitialDataResolver,
        },
        children   : [
            {path: 'cards', loadChildren: () => import('app/modules/admin/cards/cards.module').then(m => m.CardsModule)},
            {path: 'customers', loadChildren: () => import('app/modules/admin/customer/customer.module').then(m => m.CustomerModule)},
            {path: 'locations', loadChildren: () => import('app/modules/admin/location/location-module').then(m => m.LocationModule)},
            // {path: 'user-header', loadChildren: () => import('app/modules/admin/user/sub-header/sub-header.module').then(m => m.SubHeaderModule)},
            {path: 'users', loadChildren: () => import('app/modules/admin/user/user.module').then(m => m.UserModule)},
            // {path: 'changePassword', loadChildren: () => import('app/modules/admin/user/change-password/change-password.module').then(m => m.ChangePasswordModule)},
            {path: 'groups', loadChildren: () => import('app/modules/admin/group/group.module').then(m => m.GroupModule)},
            {path: 'accounts', loadChildren: () => import('app/modules/admin/account/account.module').then(m => m.AccountModule)},
            {path: 'things', loadChildren: () => import('app/modules/admin/things/things.module').then(m => m.ThingModule)},
            {path: 'print', loadChildren: () => import('app/modules/admin/print-options/print-options.module').then(m => m.PrintOptionsModule)},
            {path: 'config/roles', loadChildren: () => import('app/modules/admin/config/permissions/permissions.module').then(m => m.PermissionsModule)},
            {path: 'config/settings/generate-api-key', loadChildren: () => import('app/modules/admin/config/generate-api-key/generate-api-key.module').then(m => m.GenerateApiKeyModule)},
            {path: 'licenses', loadChildren: () => import('app/modules/admin/licenses/licenses.module').then(m => m.LicensesModule)},
            {path: 'config/customization', loadChildren: () => import('app/modules/landing/public/upload/upload.module').then(m => m.UploadModule)},
            {
            //   path: 'config/customization/jobList',
            path: 'config/settings/jobList',
              loadChildren: (): any => import('app/modules/admin/shared/components/job-list/job-list.module')
                  .then(m => m.JobListModule),
            },
            {path: 'report', loadChildren: () => import('app/modules/admin/reports/reports.module').then(m => m.ReportsModule)},
            {path: 'payment-gateway', loadChildren: () => import('app/modules/admin/payment-gateway/payment-gateway.module').then(m => m.PaymentGatewayModule)},
            {path: 'third-party-software', loadChildren: () => import('app/modules/admin/third-party-software/third-party-software.module').then(m => m.ThirdPartySoftwareModule)},

            {path: 'config/settings/profile', loadChildren: () => import('app/modules/admin/settings/settings.module').then(m => m.SettingsModule)},
            {path: 'config/settings/identity-provider', loadChildren: () => import('app/modules/admin/settings/auth-configuration/auth-configuration.module').then(m => m.AuthConfigurationModule)},
            {path: 'config/settings/software-udpate', loadChildren: () => import('app/modules/admin/settings/software-update/software-update.module').then(m => m.SoftwareUpdateModule)},
            {path: 'config/settings/custom-text', loadChildren: () => import('app/modules/admin/custom-text/custom-text.module').then(m => m.CustomTextModule)},
            {path: 'config/settings/terms-of-use', loadChildren: () => import('app/modules/admin/custom-terms-and-service/custom-terms-and-service.module').then(m => m.CustomTermsAndServiceModule)},
            {path: 'config/settings/logs', loadChildren: () => import('app/modules/admin/audit-logs/audit-logs.module').then(m => m.AuditLogsModule)},
            {path: 'config/settings/mobile-configuration', loadChildren: () => import('app/modules/admin/mobile-configuration/mobile-configuration.module').then(m => m.MobileConfigurationModule)},

            {path: 'user-info', loadChildren: () => import('app/modules/admin/user-settings/user-settings.module').then(m => m.UserSettingsModule)},

            {path: 'user-details', loadChildren: () => import('app/modules/user/user-details/user-details.module').then(m => m.UserDetailsModule)},
            {path: 'prices', loadChildren: () => import('app/modules/user/prices/prices.module').then(m => m.PricesModule)},
            {path: 'transactions', loadChildren: () => import('app/modules/user/transactions/transactions.module').then(m => m.TransactionsModule)},
            {path: 'usage', loadChildren: () => import('app/modules/user/usage/usage.module').then(m => m.UsageModule)},
            {path: 'print-release', loadChildren: () => import('app/modules/user/print-release/print-release.module').then(m => m.PrintReleaseModule)},
            {path: 're-print', loadChildren: () => import('app/modules/user/re-print/re-print.module').then(m => m.RePrintModule)},
            {path: 'add-value', loadChildren: () => import('app/modules/user/add-value/add-value.module').then(m => m.AddValueModule)},
            // Apps
            {path: 'apps', children: [
               // {path: 'ecommerce', loadChildren: () => import('app/modules/admin/apps/ecommerce/ecommerce.module').then(m => m.ECommerceModule)},
               // {path: 'contacts', loadChildren: () => import('app/modules/admin/apps/contacts/contacts.module').then(m => m.ContactsModule)},
            ]},
             // Dashboards
         {path: 'dashboards', children: [
            {path: 'analytics', loadChildren: () => import('app/modules/admin/dashboards/analytics/analytics.module').then(m => m.AnalyticsModule)},
        ]},
        {path: '**', redirectTo: localStorage.getItem('landingPage') || 'user/sign-in'}
        ]
    },
];
